<script setup lang="ts">
  import { copyrightYear } from '@/functions/copyright-year'

  const version = __APP_VERSION__
  const companyNameLong = import.meta.env.VITE_APP_COMPANY_NAME_LONG
</script>

<template>
  <footer class="text-sm border-t">
    <div class="px-4">
      v{{ version }} {{ companyNameLong }}
      &copy;{{ copyrightYear() }}
    </div>
  </footer>
</template>

<style>
  @reference "@/assets/styles/main.css";

  :root {
    --footer-height: 4rem; /* 1rem 16px */
  }

  footer {
    height: var(--footer-height);
    @apply lg:!pl-[var(--sidebar-width)];
    @apply flex items-center;
  }
</style>
